import { render, staticRenderFns } from "./WaybillTypeCreateEdit.vue?vue&type=template&id=5391c2e6&scoped=true&"
import script from "./WaybillTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./WaybillTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./WaybillTypeCreateEdit.vue?vue&type=style&index=0&id=5391c2e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391c2e6",
  null
  
)

export default component.exports